import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../css/featureDetail.css";

const FeatureTapApply = () => (
  <>
    <Helmet>
      <title>Tap & Apply — Instant Loan from Your Phone | Salary Uncle</title>
      <meta name="description" content="Apply for a salary loan anytime, anywhere directly from your smartphone. Salary Uncle's Tap & Apply feature makes loan applications effortless and instant." />
    </Helmet>

    <section className="fd-hero">
      <div className="fd-hero-inner">
        <Link to="/" className="fd-back">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          Back to Home
        </Link>
        <div className="fd-hero-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
            <rect x="5" y="2" width="14" height="20" rx="2"/>
            <circle cx="12" cy="17" r="1" fill="#fff"/>
            <line x1="9" y1="6" x2="15" y2="6"/>
          </svg>
        </div>
        <span className="fd-tag">FEATURE</span>
        <h1>Tap &amp; Apply</h1>
        <p>Apply for a salary loan anytime, from anywhere — entirely from your smartphone in under 5 minutes.</p>
      </div>
    </section>

    <section className="fd-body">
      <div className="fd-body-inner">
        <div className="fd-highlights">
          {[
            { title: "100% Mobile-Friendly", desc: "Our platform is fully optimized for smartphones. No laptop or desktop needed." },
            { title: "Apply in Under 5 Minutes", desc: "Minimal steps. Just fill in your basic details and submit — we handle the rest." },
            { title: "24/7 Availability", desc: "Apply at midnight, on weekends, on holidays. Salary Uncle never sleeps." },
            { title: "Instant Pre-Approval", desc: "Get a pre-approval decision on your screen within seconds of submission." },
            { title: "Secure & Encrypted", desc: "Bank-level 256-bit SSL encryption keeps your data safe at every step." },
            { title: "No Branch Visits", desc: "The entire process — from application to disbursal — happens digitally." },
          ].map((h, i) => (
            <div className="fd-highlight-card" key={i}>
              <div className="fd-hl-num">{String(i + 1).padStart(2, "0")}</div>
              <div>
                <div className="fd-hl-title">{h.title}</div>
                <div className="fd-hl-desc">{h.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="fd-steps-box">
          <h2>How It Works</h2>
          <div className="fd-steps">
            {[
              { step: "1", text: "Open the Salary Uncle website or app on your phone." },
              { step: "2", text: "Click 'Apply Now' and enter your mobile number." },
              { step: "3", text: "Fill in your salary and employment details." },
              { step: "4", text: "Upload KYC documents (Aadhaar, PAN) digitally." },
              { step: "5", text: "Receive approval and funds directly in your bank account." },
            ].map((s, i) => (
              <div className="fd-step-row" key={i}>
                <div className="fd-step-dot">{s.step}</div>
                <div className="fd-step-text">{s.text}</div>
              </div>
            ))}
          </div>
          <Link to="/apply-now" className="fd-cta-btn">Apply Now</Link>
        </div>
      </div>
    </section>
  </>
);

export default FeatureTapApply;
